// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2MM-T","left":"InfoRow_left__wBoRT"};